/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function')
    ? /*@__PURE__*/ Symbol.for('rxSubscriber')
    : '@@rxSubscriber';
export var $$rxSubscriber = rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/symbol/rxSubscriber.js
// module id = 472
// module chunks = 2